"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LessonSlideTaskFillGaps = void 0;
var enums_1 = require("./enums/");
/**
 * Cлайд задания типа "Заполнить пропуски в тексте"
 */
var LessonSlideTaskFillGaps = /** @class */function () {
  function LessonSlideTaskFillGaps() {
    this.type = enums_1.LessonSlideContentTypeEnum.TaskFillGaps;
    /**
     * Список возможных вариантов для режима урока
     *
     * @see LessonSlideTaskGapsItemDropbox
     */
    this.options = [];
  }
  return LessonSlideTaskFillGaps;
}();
exports.LessonSlideTaskFillGaps = LessonSlideTaskFillGaps;
